<template>
    <div class="d-inline-block">
        <button type="button"
                @click="showModal"
                class="btn"
                :class="buttonClass"
        >
            <font-awesome-icon v-if="buttonIcon !== undefined" :icon="buttonIcon" />
            <span class="button-name">{{buttonName}}</span>
        </button>
        <b-modal ref="modal" :title="modalTitle">
            <div class="d-block pt-3 pb-3 text-center">
                <font-awesome-icon :icon="modalIcon" size="3x"/>
                <div class="mt-1">{{modalText}}</div>
            </div>
            <div slot="modal-footer">
                <button type="button" class="btn btn-danger btn-sm" @click="hideModal()">
                    <font-awesome-icon icon="times"/>
                    {{t('No')}}
                </button>
                <button type="button" class="btn btn-success btn-sm" @click="doAction()">
                    <font-awesome-icon icon="check"/>
                    {{t('Yes')}}
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            modalText: {
                type: String
            },
            modalIcon: {
                type: String,
                'default': 'trash-alt'
            },
            modalName: {
                type: String,
            },
            buttonName: {
                type: String,
                required: true
            },
            buttonIcon: {
                type: String,
            },
            buttonClass: {
                type: String,
                'default': 'btn-primary'
            }
        },
        computed: {
            modalTitle() {
                return this.modalName !== undefined ? this.modalName : this.buttonName;
            }
        },
        methods: {
            doAction() {
                this.hideModal();
                document.body.classList.remove('modal-open');
                this.$emit('accepted');
            },
            showModal() {
                this.$refs.modal.show()
            },
            hideModal() {
                this.$refs.modal.hide()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/core/AcceptAction.vue